import { Box, Typography, Button } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as FailureIconVs } from 'src/assets/svg/failure-red-circle.svg';
import { ReactComponent as FailureIconHos } from 'src/assets/svg/failure-red-circle-hos.svg';
import { appConfig } from 'src/app';
import { getTheme } from 'src/utils/getTheme';

import { styles } from './styles';

const { isHosTheme } = getTheme();

const FailureIcon: FC = () => (isHosTheme ? <FailureIconHos /> : <FailureIconVs />);

export const BookingUpdateExpiredPage: FC = () => {
    const { t } = useTranslation();
    const accountPage = isHosTheme ? appConfig.myAccountUrl.hos : appConfig.myAccountUrl.vs;

    return (
        <Box css={styles.container}>
            <Box css={styles.imageContainer} />

            <Box css={styles.wrapper}>
                <FailureIcon />

                <Typography variant="h1" css={styles.title}>
                    {t('booking_update_expired_title')}
                </Typography>

                <Typography
                    variant="body3"
                    dangerouslySetInnerHTML={{ __html: t('booking_update_expired_content') }}
                />

                <Button variant="contained" css={styles.cta} href={accountPage}>
                    {t('success_btn')}
                </Button>
            </Box>
        </Box>
    );
};
